/**
 * Component that depicts a bearing in degrees as a triangular arrow.
 */
var BearingComponent = /** @class */ (function () {
    function BearingComponent() {
        this.baseWidth = 4;
        this.baseHeight = 10;
        /**
         * Arrow color (any valid HTML color)
         */
        this.color = 'black';
        /**
         * Multiplier used to control the size of the arrow (1 by default)
         */
        this.scale = 1;
    }
    Object.defineProperty(BearingComponent.prototype, "style", {
        get: function () {
            return {
                transform: "rotate(" + this.bearing + "deg)",
                borderTopColor: "" + this.color,
                borderTopWidth: this.scale * this.baseHeight + "px",
                borderLeftWidth: this.scale * this.baseWidth + "px",
                borderRightWidth: this.scale * this.baseWidth + "px"
            };
        },
        enumerable: true,
        configurable: true
    });
    return BearingComponent;
}());
export { BearingComponent };
